import {on} from 'delegated-events'

// When user selects an item from the autocomplete list, update the selected
on('click', '.js-manager-target-autocomplete-item', function (event) {
  const item = event.currentTarget
  if (!(item instanceof Element)) return

  const managerId = item.getAttribute('data-manager-id')
  const managerType = item.getAttribute('data-manager-type')

  const form = item.closest('.js-app-manager-permission-grant-form')!
  const formManagerId = form.querySelector('#manager_id') as HTMLInputElement
  const formManagerType = form.querySelector('#manager_type') as HTMLInputElement

  if (formManagerId && formManagerType && managerId && managerType) {
    formManagerId.value = managerId
    formManagerType.value = managerType
  }
})
